import { httpsCallable } from "firebase/functions";
import { functions } from "../lib/firebase";
import type {
  SendInvitationEmailsInput,
  SendInvitationEmailsResponse,
  MarkInvitationEmailSentManuallyInput,
  MarkInvitationEmailSentManuallyResponse,
} from "@event-planner/shared";

/**
 * Bulk send invitation emails for the supplied invitation IDs. Replaces
 * the per-row resend flow with a filter-driven action surfaced in the
 * Attendees-page filter row.
 */
const sendInvitationEmailsCallable = httpsCallable<
  SendInvitationEmailsInput,
  SendInvitationEmailsResponse
>(functions, "sendInvitationEmails");

export async function sendInvitationEmails(
  input: SendInvitationEmailsInput,
): Promise<SendInvitationEmailsResponse> {
  const result = await sendInvitationEmailsCallable(input);
  return result.data;
}

/**
 * Records that an organizer sent the invitation email out-of-band. Sets
 * `emailMarkedSentManuallyAt` on each invitation; pass `marked: false` to
 * clear the flag.
 */
const markInvitationEmailSentManuallyCallable = httpsCallable<
  MarkInvitationEmailSentManuallyInput,
  MarkInvitationEmailSentManuallyResponse
>(functions, "markInvitationEmailSentManually");

export async function markInvitationEmailSentManually(
  input: MarkInvitationEmailSentManuallyInput,
): Promise<MarkInvitationEmailSentManuallyResponse> {
  const result = await markInvitationEmailSentManuallyCallable(input);
  return result.data;
}
